// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9befe035","453":"80277a13"}[chunkId] + ".chunk.js";
};